var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      on: {
        mouseover: _vm.pauseRemovingOfNotification,
        mouseout: _vm.unpouseRemoving
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "notification-container",
          attrs: { id: _vm.indexOfNotification }
        },
        [
          _c("div", { staticClass: "content-wrapper" }, [
            _c("img", {
              class: [
                {
                  success: _vm.type.toLowerCase() === _vm.NOTIFICATIONS.SUCCESS
                },
                { error: _vm.type.toLowerCase() === _vm.NOTIFICATIONS.ERROR },
                { info: _vm.type.toLowerCase() === _vm.NOTIFICATIONS.INFO },
                {
                  warning: _vm.type.toLowerCase() === _vm.NOTIFICATIONS.WARNING
                }
              ],
              attrs: {
                src: require(`@/drc/assets/icons/${_vm.type.toLowerCase()}.svg`),
                alt: _vm.type
              }
            }),
            _c(
              "span",
              {
                class: [
                  {
                    success:
                      _vm.type.toLowerCase() === _vm.NOTIFICATIONS.SUCCESS
                  },
                  { error: _vm.type.toLowerCase() === _vm.NOTIFICATIONS.ERROR },
                  { info: _vm.type.toLowerCase() === _vm.NOTIFICATIONS.INFO },
                  {
                    warning:
                      _vm.type.toLowerCase() === _vm.NOTIFICATIONS.WARNING
                  },
                  "text"
                ]
              },
              [_vm._v(" " + _vm._s(_vm.message))]
            )
          ]),
          _c("img", {
            class: [
              { success: _vm.type.toLowerCase() === _vm.NOTIFICATIONS.SUCCESS },
              { error: _vm.type.toLowerCase() === _vm.NOTIFICATIONS.ERROR },
              { info: _vm.type.toLowerCase() === _vm.NOTIFICATIONS.INFO },
              { warning: _vm.type.toLowerCase() === _vm.NOTIFICATIONS.WARNING },
              "notification-close"
            ],
            attrs: {
              src: require("@/drc/assets/icons/close.svg"),
              alt: "close"
            },
            on: {
              click: function($event) {
                return _vm.closeNotification($event)
              }
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }